import { useSnackbar } from "providers/SnackbarProvider";
import { useState } from "react";
import { useForm, useWatch } from "react-hook-form";

import { useConfirmDialogExit } from "hooks";
import { useAppDispatch, useAppSelector } from "store/store";
import {
  SingleStepBody,
  SingleStepDialog,
  SingleStepFooter,
  SingleStepHeaders,
} from "components/SingleStepDialog";
import {
  buttonSendEmail,
  formShareAnswers,
  labelAnswer,
  labelAnswers,
  labelShare,
  modalShareAnswersSubtitle,
  modalShareAnswerSubtitle,
  snackbarSendEmail,
  snackbarSendEmails,
  snackbarSendEmailsSubtitle,
  snackbarSendEmailSubtitle,
  snackbarSeveritySuccess,
} from "_constants";
import { FormShareAnswer } from "components/form/FormShareAnswer";
import { shareAnswer } from "services";
import { resetCheckIds, setSelect } from "store/slicer/GestioneSaveAnswerSlice";
import { FooterShareAnswers } from "./components/FooterShareAnswers";

export const ModalShareAnswers = ({
  showDialog = false,
  onClose,
  detailId,
}: {
  showDialog: boolean;
  onClose: Function;
  detailId?: string;
}) => {
  const [visible, setVisible] = useState(showDialog);
  const { showSnackbar } = useSnackbar();
  const dispatch = useAppDispatch();
  const { showConfirmDialogExit } = useConfirmDialogExit();
  const checkIds = useAppSelector(
    (state) => state.gestioneSaveAnswerSlice.checkIds
  );

  const { handleSubmit, control } = useForm({
    defaultValues: {
      emailList: [],
      answersIdsList: detailId ? [detailId] : checkIds,
    },
    shouldFocusError: false,
    mode: "onChange",
  });

  const emailList = useWatch({
    control,
    name: "emailList",
  });

  const onSubmit = (formData: any) => {
    shareAnswer(formData)
      .then((_) => {
        showSnackbar({
          severity: snackbarSeveritySuccess,
          summary:
            emailList.length === 1 ? snackbarSendEmail : snackbarSendEmails,
          detail:
            emailList.length === 1
              ? snackbarSendEmailSubtitle
              : snackbarSendEmailsSubtitle,
        });
        dispatch(resetCheckIds());
        dispatch(setSelect(false));
        onClose();
      })
      .catch((_) => {});
  };

  const handleDismiss = () => {
    if (control._getDirty()) {
      showConfirmDialogExit({ rejectCallback: resetFormState });
    } else {
      resetFormState();
    }
  };

  const resetFormState = () => {
    control._reset();
    setVisible(false);
    onClose();
  };

  const stopPropagation = (e: any) => {
    e.stopPropagation();
  };

  return (
    <div onClick={(e) => stopPropagation(e)}>
      <SingleStepDialog
        onHideCallback={handleDismiss}
        height="auto"
        width="700px"
        header={
          <SingleStepHeaders
            title={
              labelShare +
              " " +
              (checkIds.length === 1
                ? labelAnswer.toLowerCase()
                : labelAnswers.toLowerCase())
            }
            subtitle={
              checkIds.length === 1
                ? modalShareAnswerSubtitle
                : modalShareAnswersSubtitle
            }
          />
        }
        body={
          <SingleStepBody
            content={
              <form
                id={formShareAnswers}
                onSubmit={handleSubmit(onSubmit)}
                className="width-100 padd-top-4"
              >
                <FormShareAnswer control={control} />
              </form>
            }
          />
        }
        footer={
          <SingleStepFooter
            dismiss={handleDismiss}
            form={formShareAnswers}
            labelSubmit={buttonSendEmail}
            template={<FooterShareAnswers emailListLength={emailList.length} />}
          />
        }
        display={visible}
        setVisible={setVisible}
      />
    </div>
  );
};
